import React, { useState, useEffect } from "react";
import { InputFieldOptions, ProvinceDropdown } from "./InputField";
import ConfirmationDialog from "./modalPopup";
import { useFetcher } from "react-router-dom";

export const AccountInfo = ({
  handleChange,
  handleUpdate,
  userData,
  logout,
  cancelModify,
  deleteAccount,
  handleNumberChange,
}) => {
  useEffect(() => {
    console.log("USERDATA:", userData);
  }, []);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [selectedProvince, setSelectedProvince] = useState("");

  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => setIsModalOpen(false);
  const handleDeleteAccount = () => {
    // Aggiungi qui la logica per la cancellazione dell'account
    handleCloseModal();
    alert("Account deleted!"); // Azione di esempio
  };
  return (
    <div>
      <h2 className="text-2xl text-left font-bold mb-6">
        Informazioni Account
      </h2>

      <form className="space-y-6" onSubmit={handleUpdate}>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
          <InputFieldOptions
            label="Nome"
            id="nome"
            value={userData.nome}
            onChange={handleChange}
          />
          <InputFieldOptions
            label="Cognome"
            id="cognome"
            value={userData.cognome}
            onChange={handleChange}
          />
        </div>

        <div>
          <InputFieldOptions
            label="Email"
            id="email"
            value={userData.email}
            onChange={handleChange}
          />
        </div>
        <div className="bg-red-s500 w-1/3">
          <InputFieldOptions
            label="NumTel"
            id="num_tel"
            value={userData.num_tel}
            onChange={handleNumberChange}
            type="tel"
          />
        </div>

        <div className="grid grid-cols-3 gap-4">
          <ProvinceDropdown
            label="Provincia"
            id="provincia"
            value={userData.provincia}
            onChange={handleChange}
          />
          <InputFieldOptions
            label="Comune"
            id="comune"
            value={userData.comune}
            onChange={handleChange}
          />
          <InputFieldOptions
            label="Indirizzo"
            id="indirizzo"
            value={userData.indirizzo}
            onChange={handleChange}
          />

          <InputFieldOptions
            label="Cap"
            id="cap"
            value={userData.cap}
            onChange={handleChange}
          />
        </div>
        <div className="flex justify-between">
          <button className="block font-semibold text-gray-700">
            Modifica password
          </button>
          <div>
            <button
              onClick={cancelModify}
              className="px-2 py-2 mr-5 bg-white border-2 border-gray-300 text-black rounded hover:border-gray-600 transition duration-300"
            >
              Annulla modifiche
            </button>
            <button
              type="submit"
              className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 transition duration-300"
            >
              Aggiorna
            </button>
          </div>
        </div>
        <hr />
        <div className="flex justify-between">
          <button
            onClick={logout}
            className="px-4 py-2 bg-white-500 border-2 border-black text-black rounded hover:bg-black hover:text-white transition duration-300"
          >
            Logout
          </button>
          <button
            type="button"
            onClick={() => {
              handleOpenModal();
            }}
            className="px-4 py-2 bg-white border-2 border-red-500 text-red-500 rounded hover:bg-red-500 hover:text-white transition duration-300"
          >
            Elimina account
          </button>
          <ConfirmationDialog
            isOpen={isModalOpen}
            onClose={handleCloseModal}
            onConfirm={handleDeleteAccount}
            title="Conferma Azione"
            message="Sei sicuro di voler disattivare il tuo account? Tutti i
            dati verranno rimossi in modo permanente. Questa azione non può
            essere annullata."
            confirmLabel="Elimina"
            cancelLabel="Annulla"
            iconColor="text-red-600" // Default color for delete actions
            iconBgColor="bg-red-100"
            confirmBgColor="bg-red-500"
            confirmHoverBgColor="hover:bg-red-600"
            confirmTextColor="text-white"
          />
        </div>
      </form>
    </div>
  );
};
